import { getInboxUrl } from "../../services/InboxService";
import {
  SET_MESSAGE_CENTRE_URL,
  RESET_MESSAGE_CENTRE_URL
} from "./../../reducers/messageCentre/MessageCentreReducer";
import { Paths } from "../../constants/UrlConstants";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export const resetMessageCentreUrl = () => {
  return {
    type: RESET_MESSAGE_CENTRE_URL
  };
};

export const setMessageCentreUrl = (page, history) => {
  return async (dispatch, getState) => {
    const membershipNumber =
      getState().policyReducer &&
      getState().policyReducer.selectedPolicy &&
      getState().policyReducer.selectedPolicy.MembershipNumber;
    try {
      const response = await getInboxUrl(membershipNumber, page, "");
      dispatch({
        type: SET_MESSAGE_CENTRE_URL,
        payload: response
      });
    } catch (error) {
      trackException(
        redirectToErrorPageMessage,
        `Something went wrong while fetching inbox url. MembershipNumber: ${JSON.stringify(
          membershipNumber
        )} Page: ${page}`
      );
      history.push(Paths.Error);
    }
  };
};
